import { ref, watch } from 'vue';
import { JobItem, SearchFilters, PaginationMeta } from '@/modules/content-blocks/interfaces/jobs-block.interface';
import { searchJobs } from '@/modules/content-blocks/services/positions.service';
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';
import { storeToRefs } from 'pinia';

export function useJobs(searchFilters: Ref<SearchFilters>, page: Ref<number>, perPage: number = 25) {
   const jobBoardStore = useJobBoardStore();
   const { availableFilters } = storeToRefs(jobBoardStore);

   const jobs: Ref<JobItem[]> = ref([]);
   const isLoading = ref(false);

   const meta: Ref<PaginationMeta> = ref({
      current_page: 1,
      per_page: perPage,
      total: 0,
   });

   const aggregations = ref({
      cities: [],
      job_types: [],
      work_schedules: [],
   });

   async function executeSearch() {
      const { data, isLoading: loading } = searchJobs(
         searchFilters.value,
         jobBoardStore.currentJobBoard.url,
         jobBoardStore.currentJobBoard.tenant_id,
         jobBoardStore.currentJobBoard.id,
         page.value,
         perPage,
      );

      isLoading.value = loading.value;

      watch(
         data,
         (newData) => {
            jobs.value = newData?.data || [];
            aggregations.value = newData?.aggregations || [];
            if (newData?.meta) {
               meta.value = newData.meta;
            }
         },
         { immediate: true },
      );
      watch(loading, (newLoading) => {
         isLoading.value = newLoading;
      });
   }

   executeSearch();
   watch([searchFilters, page], () => executeSearch(), { deep: true });

   return {
      jobs,
      aggregations,
      isLoading,
      availableFilters,
      meta,
   };
}
